import React from 'react';
import * as ReactRedux from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import withInit from 'WithInit';
import classnames from 'classnames';
import { getCoords } from 'Utils';
import {
  addStaticBuilderOnSectionLoadAction,
  setStaticBuilderMenuButton,
} from './StaticBuilderActions';

const BOOTSTRAP_SM_WIDTH = 768;

class NavSideBarMenuButton extends React.PureComponent {
  static scrollToCurrentStep() {
    const maxOffsetTop = 725;
    const offsetTopAdjustment = 150;
    const coords = getCoords(document.querySelector('.builder-nav li.active'));
    if (coords.top > maxOffsetTop) {
      document.querySelector('.builder-nav').scrollTop = document.querySelector('.builder-nav').scrollTop + (coords.top - offsetTopAdjustment);
    }
  }

  constructor(props) {
    super(props);
    this.handleResize = this.handleResize.bind(this);
    this.onClick = this.onClick.bind(this);
    this.onResize = this.onResize.bind(this);

    this.state = {
      isMobile: false,
    };

    this.props.addStaticBuilderOnSectionLoadAction(
      NavSideBarMenuButton.scrollToCurrentStep,
    );
  }

  componentDidMount() {
    window.addEventListener('resize', this.onResize);
    this.handleResize(window.innerWidth);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onResize);
  }

  onClick() {
    window._track('Side By Side Preview Sliding Section', this.props.documentType);

    const builderNavNode = document.getElementById('builderNav');
    const staticBuilderContentNode = document.getElementById('staticBuilderContent');
    const documentPreviewWrapperNode = document.getElementById('documentPreviewWrapper');
    const sectionProgressNode = document.getElementById('sectionProgress');

    if (this.props.isMenuOpen) {
      builderNavNode.classList.add('collapsed');
      builderNavNode.style.display = 'none';
      staticBuilderContentNode.classList.add('expanded');
      documentPreviewWrapperNode.classList.add('expanded');
      sectionProgressNode.classList.remove('navbar-opened');
    } else {
      builderNavNode.classList.remove('collapsed');
      builderNavNode.style.display = 'block';
      staticBuilderContentNode.classList.remove('expanded');
      documentPreviewWrapperNode.classList.remove('expanded');
      sectionProgressNode.classList.add('navbar-opened');
    }

    this.props.setStaticBuilderMenuButton(!this.props.isMenuOpen);
  }

  onResize(e) {
    this.handleResize(e.target.innerWidth);
  }

  handleResize(innerWidth) {
    const builderContainerNode = document.getElementById('builderContainer');
    const builderNavNode = document.getElementById('builderNav');
    const staticBuilderContentNode = document.getElementById('staticBuilderContent');
    const documentPreviewWrapperNode = document.getElementById('documentPreviewWrapper');

    if (innerWidth < BOOTSTRAP_SM_WIDTH) {
      staticBuilderContentNode.classList.remove('expanded');
      documentPreviewWrapperNode.classList.remove('expanded');
      builderNavNode.classList.remove('collapsed');

      // Only want to hide the navigation if it's been set to hide
      // based on split test where we have V3 hiding the preview to begin with
      // and want to hide navigation when the preview is visible
      builderNavNode.style.display = this.props.isBuilderHidden ? 'none' : 'block';
      builderContainerNode.appendChild(builderNavNode);
      this.setState({ isMobile: true });
    } else {
      if (!this.props.isMenuOpen) {
        builderNavNode.style.display = 'none';
        staticBuilderContentNode.classList.add('expanded');
        documentPreviewWrapperNode.classList.add('expanded');
      }

      staticBuilderContentNode.parentNode.insertBefore(builderNavNode, staticBuilderContentNode);
      this.setState({ isMobile: false });
    }
  }

  render() {
    const imgSrc = this.props.isMenuOpen ? 'icon-nav-close.png' : 'icon-nav-menu.png';
    const buttonClassName = classnames('builder-side-bar-menu-button', {
      hidden: this.state.isMobile,
      'is-closed': !this.props.isMenuOpen,
    });

    return (
      <button
        className={buttonClassName}
        id="staticMenuButton"
        onClick={this.onClick}
      >
        <span>MENU</span>
        <img
          alt=""
          className="builder-toolbar-arrow-img"
          src={`${window.cdnUrl}/images/icons/${imgSrc}`}
        />
      </button>
    );
  }
}

NavSideBarMenuButton.defaultProps = {
  isMenuOpen: false,
};

NavSideBarMenuButton.propTypes = {
  addStaticBuilderOnSectionLoadAction: PropTypes.func.isRequired,
  documentType: PropTypes.string.isRequired,
  isBuilderHidden: PropTypes.bool.isRequired,
  isMenuOpen: PropTypes.bool,
  setStaticBuilderMenuButton: PropTypes.func.isRequired,
};

const mapStateToProps = ({ StaticBuilderReducer }) => ({
  isMenuOpen: StaticBuilderReducer.isMenuOpen,
  isBuilderHidden: StaticBuilderReducer.isBuilderHidden,
});

const mapDispatchToProps = dispatch => (
  bindActionCreators({
    addStaticBuilderOnSectionLoadAction,
    setStaticBuilderMenuButton,
  }, dispatch)
);

export const NavSideBarMenuButtonWithRedux = ReactRedux.connect(
  mapStateToProps,
  mapDispatchToProps,
)(NavSideBarMenuButton);

export default withInit(NavSideBarMenuButtonWithRedux, true);



// WEBPACK FOOTER //
// ./src-react/StaticBuilder/NavSideBarMenuButton.jsx